import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import { SignalRProvider } from './Services/SignalRContext';

ReactDOM.render(
  <LayoutProvider>
        <UserProvider>
            <SignalRProvider>
                <App/>
            </SignalRProvider>
    </UserProvider>
  </LayoutProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.unregister();
